module.exports = __webpack_public_path__ + "media/images/en/expired-97c8eacc4ebc13b6d3832ec9775b8ab0.png";